import React,{Component} from 'react';

import {reduxForm} from 'redux-form';
import * as actions from './../../actions';
import {Link} from 'react-router';
import {  Button, Modal} from 'react-bootstrap';
import Footer from './Footer.js';
import $ from 'jquery';
// import $ from 'jquery';
import Header from './Header.js';
class Web_EnquireNow extends Component{
	constructor(props){
		super(props);
			this.state={
					ltype : this.props.params.Ltype,
					sid: this.props.params.Sid,
					did: this.props.params.Did,
					showModal: false,
			};
	this.modalOpen=this.modalOpen.bind(this);
    this.close=this.close.bind(this);
    this.closeModal=this.closeModal.bind(this);
	};
  modalOpen(){
  this.setState({
    showModal: true
  });
}
closeModal(){
  this.setState({
    showModal: false,
  });
}
close(){
  this.setState({
    showModal: false,
  });
}

componentWillReceiveProps(newProps) {
    if (newProps.leads === 1 || newProps.leads.status === 'success') {
      this.setState({showModal: true});
    } else {
      this.setState({showModal: false});
    }
}
getDeviceId(){
    if(localStorage.user_id){
        var user_id=localStorage.user_id;
    }
    else{
      user_id=0;
    }
    var data1={from: 'desktop_web',id: user_id, device_id: localStorage.getItem('push_device_id')}
    var data2=JSON.stringify(data1);
    var baseUrl='https://aquadeals.in/admin/web3/user/';
    $.ajax({
        method: 'POST',
        url: baseUrl+'getDeviceId',
        dataType: 'json',
        data:{req: data2},
        success: function(data){
          
        },
        error: function(err){
        }
    });
  }

componentWillUnmount(){
	this.props.clear_state();
}
componentDidMount(){
	this.getDeviceId();
}
handleFormSubmit(formProps){
	// console.log(this.state.ltype);
	if(this.state.ltype === "seed"){
		this.props.saveseed_lead(formProps,this.state.sid,this.state.did);
	}
	if(this.state.ltype === "feed"){
		this.props.savefeed_lead(formProps,this.state.sid,this.state.did);	
	}
	if(this.state.ltype === "seller"){
	this.props.savefeed_lead(formProps,this.state.sid,this.state.did);	
		//this.props.track_seller_lead(formProps,this.state.sid,this.state.did);	
	}
	if(this.state.ltype === "nodata"){
		this.props.track_user_lead(formProps,this.state.sid,this.state.did);	
	}	
  }

render(){
	// console.log(this.props.leads);
	document.title ="AquaDeals Enquire Now ";
  	document.getElementsByTagName("META")[2].content="AquaDeals Enquire Now";
  var redirect = '';
  if(this.state.ltype === 'seller'){
  	redirect = '/customer_care_seller';
  }else{
  	redirect = '/customer_care';
  }
  const {handleSubmit,fields:{name,number,email}} = this.props;
  return (
<div className="lgt_gry web_deals web_enquire_page">

<Header />
<div className="clr">&nbsp;</div>
<div className="clr">&nbsp;</div>

<section className="container dels_cntnt">
<div className="row">
	<div className="col-md-12 del_rgt">
		<div className="del_rgt_blk">
			<div className="col-md-12">
			{/* 	<Breadcrumb>
	                <Breadcrumb.Item href="/home">Home</Breadcrumb.Item>
	                <Breadcrumb.Item href={"/feedslist/"+this.state.dtype}>Feed Deals</Breadcrumb.Item>
	                <Breadcrumb.Item active>Enquire Now</Breadcrumb.Item>
	            </Breadcrumb>
	         */}
			</div>
		<div className="clr"></div>
<div className="customer_care">
	<div className="col-md-6 col-md-offset-3">
<div className="clr">&nbsp;</div><div className="clr">&nbsp;</div>	
{/*	<!-- login form start --> */}
	<div className="thumbnail">
	<div className="enquire_form">
	
		<div className="login_form">
			<form className="mtrl_elmnts" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
				<div className="group">      
					<input {...name}type="text" />
					<span className="highlight"></span>
					<span className="bar"></span>
					<span>{name.touched && name.error && <div className="text-danger">{name.error}</div>}</span>
					<label>Name</label>
				</div>
				<div className="group">      
					<input {...number} type="text" maxLength={10} />	
					<span className="highlight"></span>
					<span className="bar"></span>
					<span>{number.touched && number.error && <div className="text-danger">{number.error}</div>}</span>
					<label>Mobile</label>
				</div>
				<div className="group">      
					<input {...email} type="text"  />
					<span className="highlight"></span>
					<span className="bar"></span>
					<span><div className="text-danger">{email.error ? email.error : ''}</div></span>
					<label>Email(Optional)</label>
				</div>
				<div className="row">
					<div className="col-md-6 col-xs-6 col-sm-6"></div>
					<div className="col-md-6 col-xs-6 col-sm-6"><button style={{border: 'none'}} action="submit" className="btn enquire_btn">Enquire</button></div>
				</div>
			</form>
		</div>
	</div>
	</div>
{/*		<!-- login form end --> */}
		<div className="customer_care_bg">&nbsp;</div>
		<div className="clr">&nbsp;</div>
		</div>
		</div>
{/*<!-- customer care end --> */}

	<div className="clr">&nbsp;</div>
	<div className="clr">&nbsp;</div>		



			</div>
		</div>

	</div>
{/*<div className="del_dtl_btns">
		<ul>
			<li> <a className="enqir_now"> <i> <img src={'https://aquadeals.in/admin/assets/images/web_imgs/enquiry_now.png'} alt="Enquire" /> </i> Enquire Now</a> </li>
			<li> <a className="plc_ordr">Place Order <i className="glyphicon glyphicon-menu-right"> </i> </a> </li>
		</ul>
	</div>
<div className="clr">&nbsp;</div>	
<div className="clr">&nbsp;</div> */}
</section>

<Modal className="showModal modal fade" show={this.state.showModal} style={{zIndex: '1111'}} onHide={this.close}>
        <Modal.Header style={{borderBottom: 'none' }}>
                <Modal.Title style={{fontSize: 16+'px',color:'#333'}}></Modal.Title>
              </Modal.Header>
              <Modal.Body>
              	<div style={{textAlign: 'center'}}><img width={70} src={'https://aquadeals.in/admin/assets/images/web_imgs/conformed.png'} alt="..." /></div> 
                <h4 style={{textAlign: 'center', fontSize:14+'px', color:'#666'}}>Your details has been submitted successfully</h4>
              </Modal.Body>
              <Modal.Footer className="modal_footer" style={{borderTop: 'none',textAlign: 'center'}}>
                  {/* <Button style={{background: '#fff none repeat scroll 0 0',color:'#ff742a'}} onClick={ this.closeModal}>Close</Button>*/}
                  <Link to={redirect}><Button style={{background: '#ff742a none repeat scroll 0 0',color: '#fff'}}>OK</Button></Link>
              </Modal.Footer>
      </Modal>


<Footer />
</div>
    );
  }
}


function validate(formProps){
const errors = {};
const namePattern = /^[a-zA-Z0-9\x20]{3,25}/;

if(!formProps.name){
  errors.name = "Enter your name";
}else if(formProps.name && !namePattern.test(formProps.name)){
		errors.name = 'Enter minimum 3 characters';
}




const invalidChars = /[^0-9]/gi;
 if(formProps.number && invalidChars.test(formProps.number)){
 	errors.number="invalid mobile number";
 }

const number_check = /^[0-9]{10}$/;  
 if(formProps.number && !number_check.test(formProps.number)){
 	errors.number="Mobile number must contains 10 numbers only";
 }

 if(!formProps.number){
 	errors.number="Enter Mobile Number";
 }


 const emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
  if (formProps.email && !emailPattern.test(formProps.email)) {
    errors.email = 'Enter a valid email';
}




// const emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
//   if (!emailPattern.test(formProps.email)) {
//     errors.email = 'Enter a valid email';
//   }
  
return errors;
}


function mapStateToProps(state){
    return {
        leads:state.posts.leads,
    }
}

export default reduxForm({
  form :'Enquiry',
  fields:['name','number','email'],
  validate:validate
},mapStateToProps,actions)(Web_EnquireNow);


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Common/Web_enquire_now.js
 **/